import React from 'react';
import { Link, Typography } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';

export const Tabs = () => (
  <Stack
    alignItems="center"
    justifyContent={{ default: 'center', md: 'flexEnd' }}
    order={{ default: 1, md: 2 }}
    flexGrow={{ default: 1, md: 0 }}
    flexBasis={{ default: '100%', md: 'auto' }}
    gap="3"
  >
    <Link href="/news/press-releases" decoration="none">
      <Typography size="b_sm" fontWeight="normal" color="bodyPrimary" data-count-extende="0" data-count="0">
        PRESS RELEASES
      </Typography>
    </Link>
    <Link decoration="none" href="/press-kit">
      <Typography
        size="b_sm"
        fontWeight="normal"
        color={{ default: 'grey_900', hover: 'black' }}
        data-count-extende="0"
        data-count="0"
      >
        PRESS KIT
      </Typography>
    </Link>
  </Stack>
);
